import styled from "styled-components";

export const Content = styled.div`
    border-bottom: 1px solid var(--purple-2);
    padding: 0 1px;
    display: flex;
    flex-direction: column;
    & h4 {
        text-align: center;
        margin: 0;
        height: 60px;
        padding: 10px;
    }
`;